export const casinoLink: string = 'https://lvbet.lv/casino/{lang}/';

export const liveCasinoLink: string = 'https://lvbet.lv/casino/{lang}/live-casino/';
